import { Modal } from 'antd';
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';

import { ModalProps } from 'models';

import { Carousel } from 'componets/common';
import { PrimaryMarketPhotoItem } from '../PrimaryMarketPhotoItem';

import './index.scss';

interface PrimaryItemPhotosModalProps extends ModalProps {
	length: number;
	current: number;
	onSetCurrent: Dispatch<SetStateAction<number>>;
	images: string[];
}

export const PrimaryMarketItemPhotosModal = ({
	isOpen,
	onClose,
	length,
	current,
	images,
	onSetCurrent,
}: PrimaryItemPhotosModalProps) => {
	const [currentIndex, setCurrentIndex] = useState(current || 0);
	const changeChild = useCallback(
		(e: KeyboardEvent) => {
			if (e.key === 'ArrowLeft') {
				const newIndex = (currentIndex - 1 + length) % length;
				setCurrentIndex(newIndex);
			} else if (e.key === 'ArrowRight') {
				const newIndex = (currentIndex + 1) % length;

				setCurrentIndex(newIndex);
			}
		},
		[currentIndex, length],
	);

	useEffect(() => {
		document.addEventListener('keydown', changeChild);

		return function cleanup() {
			document.removeEventListener('keydown', changeChild);
		};
	});

	return (
		<Modal
			open={isOpen}
			onCancel={() => {
				onClose();
				onSetCurrent(0);
			}}
			closable={false}
			footer={null}
			className="carouselModal"
		>
			<div className="carouselModal__photos">
				<Carousel current={currentIndex} length={length} onSetCurrent={setCurrentIndex}>
					<div className="carouselModal__photo">
						<PrimaryMarketPhotoItem
							src={images[currentIndex]}
							isCarousel
							index={currentIndex}
							isModal
						/>
					</div>
				</Carousel>
			</div>
		</Modal>
	);
};
